import React from "react"
import { CSSProperties } from "react"
import { ReactNode } from "react"
import stylesheet from "./ShareButton.module.scss"

interface ShareButtonProps {
  order: number
  disabled?: boolean
  style?: CSSProperties
  children?: ReactNode
  onClick: () => void
}

export default function ShareButton({ order, disabled, children, style, onClick }: ShareButtonProps) {
  style.animationDelay = `${order * 50}ms`

  return (
    <button
      className={stylesheet.shareButton}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}